import ReactECharts from 'echarts-for-react';
import { Box, Typography } from '@mui/material';

const PALETTE = ['#03407b', '#1a7ac4', '#7fb3d3', '#bfdbfe'];

const BarChartt = ({ data }) => {
  if (!data?.list?.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={220}>
        <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>Aucune donnée</Typography>
      </Box>
    );
  }

  const numericValues = (data.values || []).map((v) => Number(v));

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      backgroundColor: '#1e293b',
      borderColor: 'transparent',
      textStyle: { color: '#f8fafc', fontSize: 12 },
    },
    grid: { left: 12, right: 12, top: 20, bottom: 56, containLabel: true },
    xAxis: {
      type: 'category',
      data: data.list,
      axisLabel: {
        fontSize: 11,
        color: '#64748b',
        interval: 0,
        overflow: 'truncate',
        width: 100,
        lineHeight: 16,
      },
      axisLine: { lineStyle: { color: '#e2e8f0' } },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: '#94a3b8', fontSize: 11 },
      splitLine: { lineStyle: { color: '#f1f5f9', type: 'dashed' } },
      axisLine: { show: false },
    },
    series: [
      {
        type: 'bar',
        barMaxWidth: 52,
        data: numericValues.map((v, i) => ({
          value: v,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: PALETTE[i % PALETTE.length] },
                { offset: 1, color: PALETTE[i % PALETTE.length] + '88' },
              ],
            },
            borderRadius: [6, 6, 0, 0],
          },
          emphasis: {
            itemStyle: { color: PALETTE[i % PALETTE.length], shadowBlur: 10, shadowColor: 'rgba(3,64,123,0.3)' },
          },
          label: {
            show: v > 0,
            position: 'top',
            color: '#475569',
            fontSize: 11,
            fontWeight: 600,
          },
        })),
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: 300, width: '100%' }} notMerge opts={{ renderer: 'canvas', width: 'auto', height: 'auto' }} />;
};

export default BarChartt;
